import { useEffect, useState } from 'react'
import { Text, Loader, Button, Separator } from '@/ui'
import { TypographyStyles } from '@/styles'

import { UserTodoCreationDialog } from './UserTodoCreationDialog'
import { UserWithAdminInfo } from '@/reducers/admin/allUsersReducer'
import { UserActionItemsTable } from './UserTodoTable'
import { adminFetchUserActionItems } from '@/features/user/dashboard/user-action-items/lib/userActionItems.slice'
import { getUserIdNonDeletedActionItems } from '@/features/user/dashboard/user-action-items/lib/userActionItems.selectors'
import { UserImportantDatesTable } from './UserImportantDateTable'
import { getNonDeletedImportantDates } from '@/features/user/dashboard/user-important-dates/userImportantDates.selectors'
import { adminFetchUserImportantDates } from '@/features/user/dashboard/user-important-dates/userImportantDates.slice'
import { UserImportantDateCreationDialog } from './UserImportantDateCreationDialog'
import { useReselector } from '@/utils/sharedHooks'
import {
  fetchAllImportantDates,
  fetchAllTodos,
} from '@/features/admin/action-items/allActionItems.slice'
import { useAppDispatch } from '@/utils/typeHelpers'

export const UserActionItemsPanel = ({ user }: { user: UserWithAdminInfo }) => {
  const dispatch = useAppDispatch()
  const [fetching, setFetching] = useState(true)
  const [todoModalOpen, setTodoModalOpen] = useState(false)
  const [importantDateModalOpen, setImportantDateModalOpen] = useState(false)

  const userActionItems = useReselector(getUserIdNonDeletedActionItems, user.id)
  const userImportantDates = useReselector(getNonDeletedImportantDates)

  useEffect(() => {
    async function fetch() {
      await fetchAllTodos()(dispatch)
      await fetchAllImportantDates()(dispatch)
      await adminFetchUserActionItems(user.id)(dispatch)
      await adminFetchUserImportantDates(user.id)(dispatch)
      setFetching(false)
    }
    fetch()
  }, [dispatch, user.id])

  return (
    <div id="userActionItemsPanel" className="w-full">
      {fetching && <Loader active>Fetching all data</Loader>}
      {!fetching && (
        <div>
          <br />
          <div className="flex flex-row justify-between items-center">
            <Text variant={TypographyStyles.H2}>User Todos</Text>
            <Button variant="secondary" onClick={() => setTodoModalOpen(true)}>
              Assign todo for user
            </Button>
            <UserTodoCreationDialog
              open={todoModalOpen}
              close={() => setTodoModalOpen(false)}
              userId={user.id}
            />
          </div>
          <UserActionItemsTable actionItems={userActionItems} user={user} />
          <br />
          <Separator />
          <div className="flex flex-row justify-between items-center mt-4">
            <Text variant={TypographyStyles.H2}>User Important Dates</Text>
            <Button
              variant="secondary"
              onClick={() => setImportantDateModalOpen(true)}
            >
              Assign important date for user
            </Button>
            <UserImportantDateCreationDialog
              open={importantDateModalOpen}
              close={() => setImportantDateModalOpen(false)}
              userId={user.id}
            />
          </div>
          <UserImportantDatesTable
            importantDates={userImportantDates}
            user={user}
          />
        </div>
      )}
    </div>
  )
}
